/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    title: "Phân phối, cung cấp hàng hóa. Tỷ lệ thuế GTGT 1%, thuế TNCN 0.5%",
    taxA: "",
    taxB: "",
    taxC: "",
    taxD: "",
  },
  {
    id: uuidV4(),
    title: "Dịch vụ, xây dựng không bao thầu nguyên vật liệu. Tỷ lệ thuế GTGT 5%, thuế TNCN 2%",
    taxA: "",
    taxB: "",
    taxC: "",
    taxD: "",
  },
  {
    id: uuidV4(),
    title:
      "Sản xuất, vận tải, dịch vụ có gắn với hàng hóa, xây dựng có bao thầu nguyên vật liệu, Tỷ lệ thuế GTGT 3%, thuế TNCN 1,5%",
    taxA: "",
    taxB: "",
    taxC: "",
    taxD: "",
  },
  {
    id: uuidV4(),
    title: "Hoạt động kinh doanh khác. Tỷ lệ thuế GTGT 2%, thuế TNCN 1%",
    taxA: "",
    taxB: "",
    taxC: "",
    taxD: "",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue, onChangeCount }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
    onChangeCount(data.length + 28);
  }, [data]);

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      title: "",
      taxA: "",
      taxB: "",
      taxC: "",
      taxD: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => setData((prev) => prev.filter((item) => item.id !== id));

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (id === item.id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">
        A. KÊ KHAI THUẾ GIÁ TRỊ GIA TĂNG (GTGT), THUẾ THU NHẬP CÁ NHÂN (TNCN)
      </Typography>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={3} style={{ textAlign: "center", width: 10 }}>
                STT
                <div className="button-action">
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center" }}>
                Nhóm ngành nghề
              </Td>
              <Td rowSpan={3} style={{ textAlign: "center" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Thuế GTGT
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Thuế TNCN
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Doanh thu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số thuế
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Doanh thu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số thuế
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                ( a )
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                ( b )
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                ( a )
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                ( b )
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  {index + 1 > 4 && (
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete(item.id, index)}>
                        Xóa dòng
                      </button>
                    </div>
                  )}
                </Td>
                <Td rowSpan={1} style={{ textAlign: "left", maxWidth: 100, fontStyle: "italic" }}>
                  {index + 1 > 4 ? (
                    <InputTable
                      type="text"
                      id={item.id}
                      value={item.title}
                      name="title"
                      onChange={handleChange}
                      style={{ fontStyle: "italic" }}
                    />
                  ) : (
                    item.title
                  )}
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", fontWeight: 700 }}>
                  [{index + 28}]
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable id={item.id} value={item.taxA} name="taxA" onChange={handleChange} />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  {item.taxB}
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable id={item.id} value={item.taxC} name="taxC" onChange={handleChange} />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  {item.taxD}
                </Td>
              </tr>
            ))}
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: 700 }}
              >
                Tổng cộng
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: 700 }}
              >
                [{data.length + 28}]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, type, style, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, id });
    } else {
      onChange({ value, name, id });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: !type ? "right" : "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
        ...style,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
